
const config = {

  NEW_API: {
    NEW_BASE_URL: process.env.REACT_APP_NEW_BASE_URL,
    AFCS_BASE_URL: process.env.REACT_APP_NEW_AFCS_BASE_URL,
    COA_BASE_URL: process.env.REACT_APP_NEW_COA_BASE_URL,
  },

  google_properties: {
    auth: {
      client_id: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID,
      redirect_uri: process.env.REACT_APP_GOOGLE_AUTH_REDIRECT_URI,
    },
  },

  googleProperties: {
    auth: {
      baseUrl: process.env.REACT_APP_NEW_COA_BASE_URL,
      client_id: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID,
    },
    google: {
      clientId: process.env.REACT_APP_SERVER_AUTH_CLIENT_ID,
      clientSecret: process.env.REACT_APP_SERVER_AUTH_CLIENT_SECRET,
      redirectUri: process.env.REACT_APP_SERVER_AUTH_REDIRECT_URI,
    },
  },

  cookieKeys: {
    user: process.env.REACT_APP_USER_COOKIE,
    loginState: process.env.REACT_APP_LOGIN_STATE_COOKIE,
  },
};

export default config;
